import { web3 } from '@coral-xyz/anchor';
import { Big, BN } from '@switchboard-xyz/common';
import chalk from 'chalk';

export type Value =
  | string
  | number
  | boolean
  | web3.PublicKey
  | Big
  | BN
  | undefined
  | null;

export const chalkString = (
  label: string,
  value: Value,
  padding = 16
): string => {
  let valueString: string;
  if (value === undefined) {
    valueString = 'undefined';
  } else if (typeof value === 'string') {
    valueString = value === web3.PublicKey.default.toBase58() ? 'N/A' : value;
  } else if (typeof value === 'number') {
    valueString = value.toString(10);
  } else if (typeof value === 'boolean') {
    valueString = value.toString();
  } else if (value instanceof web3.PublicKey) {
    valueString = value.equals(web3.PublicKey.default)
      ? 'N/A'
      : value.toBase58();
  } else if (value instanceof Big) {
    valueString = value.toString();
  } else if (BN.isBN(value)) {
    valueString = value.toString(10);
  } else {
    valueString = `${value}`;
  }

  return `${chalk.blue(label.padEnd(padding, ' '))}${chalk.yellow(
    valueString
  )}`;
};
